import { faCog } from '@fortawesome/pro-duotone-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faFolderOpen, faLayerPlus, faListTree } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toggleMultiNotifsMenu, toggleOptionsMenu } from '../../actions/menus';
import { startLoadingNotificationsByUser } from '../../actions/notification';
import { openCreateProjectOverlay, setAccountActivationOverlay, setNewProjectOverlay } from '../../actions/overlay';
import { changePage } from '../../actions/project';
import { isBtoBSelector, projectSelector, userSelector } from '../../selectors';
import { notifSelector } from '../../selectors/notification';
import OptionsMenuContainer from '../container-options-menu';
import CreateProjectOverlay from '../overlay-create-project';
import { CreateFolderButton, IconOverlayContainer, SidebarHeader, SidebarLinkWrapper, SidebarLogoOverlay, SidebarLogoWrapper, SidebarOverlayWrapper, SidebarWrapper, SideContentOverlayWrapper, SideOverlayWrapper } from './styled';
import { DEMO_ROUTE, MY_FOLDERS_ROUTE } from '../../constants/router';
const SidebarContainerOverlay = props => {
  const user = useSelector(userSelector);
  const dispatch = useDispatch();
  const history = useHistory();
  const isDemoProject = history.location.pathname === DEMO_ROUTE;
  const {
    selectedProject
  } = useSelector(projectSelector);
  const [homeText, setHomeText] = useState('');
  const isBtoB = useSelector(isBtoBSelector);
  const tunnelBaseUrl = window.processRuntime.env?.PAYMENT_TUNNEL_BASE_URL;
  useEffect(() => {
    if (selectedProject) {
      const {
        name,
        projectname,
        dealname
      } = selectedProject;
      setHomeText(name || projectname || dealname);
    }
  }, []);
  const {
    userNotifications,
    userNotificationsLoading,
    userNotificationsError
  } = useSelector(notifSelector);
  const handleClickSwitchProject = event => {
    event.preventDefault();
    dispatch(changePage('switch'));
    props.onClose();
    history.push(MY_FOLDERS_ROUTE);
  };
  const showOverlaySwitchProject = event => {
    if (isDemoProject) {
      dispatch(setAccountActivationOverlay());
    } else {
      handleClickSwitchProject(event);
    }
  };
  const handleClickHome = event => {
    event.preventDefault();
    dispatch(changePage('projet'));
    props.onClose();
    history.push('/');
  };
  React.useMemo(() => {
    if (user && user.profile && !userNotifications && !userNotificationsLoading && !userNotificationsError) {
      dispatch(startLoadingNotificationsByUser(user, {
        limit: 15,
        offset: 0
      }));
    }
  }, [user, userNotifications, userNotificationsLoading, userNotificationsError]);
  const handleClickCreateProject = event => {
    event.preventDefault();
    if (isDemoProject) {
      dispatch(setAccountActivationOverlay());
    } else {
      if (isBtoB) {
        dispatch(openCreateProjectOverlay());
        props.onClose();
      } else {
        dispatch(setNewProjectOverlay());
      }
    }
  };
  return /*#__PURE__*/React.createElement(SidebarOverlayWrapper, null, /*#__PURE__*/React.createElement(SideOverlayWrapper, {
    animation: props.animation
  }, /*#__PURE__*/React.createElement(SidebarWrapper, null, /*#__PURE__*/React.createElement(SideContentOverlayWrapper, null, /*#__PURE__*/React.createElement(SidebarHeader, null, /*#__PURE__*/React.createElement(SidebarLinkWrapper, {
    href: window.processRuntime.env?.HP_BASE_URL
  }, /*#__PURE__*/React.createElement(SidebarLogoOverlay, {
    src: isBtoB ? "https://pmdc-public.s3.eu-west-2.amazonaws.com/common/logos/AlgarPRO+logo.png" : "https://pmdc-public.s3.eu-west-2.amazonaws.com/common/logos/logo_algar2.svg",
    alt: "Index"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: props.onClose
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "2x",
    icon: faXmark
  }))), /*#__PURE__*/React.createElement(SidebarLogoWrapper, {
    onClick: showOverlaySwitchProject
  }, /*#__PURE__*/React.createElement(IconOverlayContainer, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "3x",
    icon: faListTree
  })), /*#__PURE__*/React.createElement("div", null, "Mes dossiers")), /*#__PURE__*/React.createElement(SidebarLogoWrapper, {
    onClick: handleClickHome
  }, /*#__PURE__*/React.createElement(IconOverlayContainer, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "3x",
    icon: faFolderOpen
  })), /*#__PURE__*/React.createElement("div", null, homeText)), /*#__PURE__*/React.createElement(CreateFolderButton, {
    onClick: handleClickCreateProject
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    color: props.theme.colors.primary,
    icon: faLayerPlus
  }), /*#__PURE__*/React.createElement("span", null, "Cr\xE9er un dossier")))), /*#__PURE__*/React.createElement(SidebarWrapper, null, /*#__PURE__*/React.createElement(OptionsMenuContainer, null))), props.createProjectOverlayOpened && /*#__PURE__*/React.createElement(CreateProjectOverlay, null));
};
const mapStateToProps = _ref => {
  let {
    router,
    menus,
    overlay
  } = _ref;
  return {
    currentRoute: router.location.pathname,
    optionsMenuOpened: menus.optionsMenuOpened,
    multiNotifsMenuOpened: menus.multiNotifsMenuOpened,
    createProjectOverlayOpened: overlay.createProjectOverlayOpened
  };
};
const mapDispatchToProps = dispatch => ({
  handleOptionsClick: event => {
    event.stopPropagation();
    return dispatch(toggleOptionsMenu());
  },
  handleNotifIconClick: event => {
    event.stopPropagation();
    return dispatch(toggleMultiNotifsMenu());
  }
});
SidebarContainerOverlay.propTypes = {
  theme: PropTypes.object.isRequired,
  currentRoute: PropTypes.string.isRequired,
  optionsMenuOpened: PropTypes.bool.isRequired,
  handleOptionsClick: PropTypes.func.isRequired,
  multiNotifsMenuOpened: PropTypes.bool.isRequired,
  handleNotifIconClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  animation: PropTypes.string.isRequired,
  sales: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(SidebarContainerOverlay));